module.exports = __webpack_public_path__ + "img/image15.abf1df40.png";